import { cloneElement, Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import {
  FormCheckbox,
  FormDropDownListById,
  FormInput,
  FormTextArea,
} from "../../../forms/form-components";
import { FormRegion } from "../../../components/formregion";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { getDataType } from "../../../lib/utils";
import {
  databaseDDL,
  timeIntervalsDDL,
} from "../../../redux/slices/createdatasetpageslice";
import {
  setConnectionFormValue,
  setFormValue,
} from "../../../redux/slices/datasetviewpageslice";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import DatasetGrid from "./datasetgrid";

export const DatasetViewPageForm = (props) => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.datasetViewPage);
  const updateDirtyState = props.updateDirtyState;
  const [tabSelected, setTabSelected] = useState(0);
  const { t } = useTranslation();
  const handleTabSelection = (e) => {
    setTabSelected(e.selected);
  };
  let columns = null;
  let updatedDatasetFields = null;
  if (pageState.formValues.Fields?.length > 0) {
    columns = Object.keys(pageState.formValues.Fields[0]).map((key) => ({
      field: key,
      title: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize title
      width: 150, // Explicit width for each column
    }));
  }

  updatedDatasetFields = pageState.formValues.Fields?.map((field) => ({
    ...field,
    DataTypeId: getDataType(field.DataTypeId), // Call getDataType for DataTypeId field
  }));

  let consumptionData = null;
  if (pageState.formValues.Consumption) {
    consumptionData = [
      {
        ...pageState.formValues.Consumption,
        Dataset: pageState.formValues.Title,
      },
    ];
  }

  let correctionColumns = null;
  let updatedCorrectionColumns = null;
  if (pageState.formValues.Corrections?.length > 0) {
    correctionColumns = Object.keys(pageState.formValues.Corrections[0]).map(
      (key) => ({
        field: key,
        title: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize title
        width: 150, // Explicit width for each column
      }),
    );
  }

  updatedCorrectionColumns = pageState.formValues.Corrections?.map((field) => ({
    ...field,
    Type:
      field.Type == 2
        ? t("datasets.datasetview.update2")
        : t("datasets.datasetview.delete2"), // Call getDataType for DataTypeId field
  }));

  //handle is dirtyyy
  useEffect(() => {
    updateDirtyState();
  }, [pageState.formInitialValues, pageState.formValues]);

  //#region functions
  const handleOnChangeConnection = (id, value) => {
    dispatch(setConnectionFormValue({ id, value }));
  };

  const handleOnChangeField = (id, value) => {
    dispatch(setFormValue({ id, value }));
  };
  //#endregion

  //#region JobCollection cells
  const JobCollectionStatusCell = (props) => {
    const { dataItem } = props;
    const isFailed = dataItem.Status === 0 || dataItem.Status === -1;

    return (
      <td style={{ color: isFailed ? "red" : "green", fontWeight: "bold" }}>
        {isFailed
          ? t("datasets.datasetview.failed")
          : t("datasets.datasetview.success")}
      </td>
    );
  };

  const jobTypeMap = {
    1: t("datasets.datasetview.jobmap1"),
    2: t("datasets.datasetview.jobmap2"),
    3: t("datasets.datasetview.jobmap3"),
    4: t("datasets.datasetview.jobmap4"),
  };

  const JobCollectionTypeCell = (props) => {
    const { dataItem } = props;
    return <td>{jobTypeMap[dataItem.JobType] || dataItem.JobType}</td>;
  };

  //#endregion

  return (
    <Fragment>
      <Form
        //validator={formValidator(pageState.mode)}
        key={pageState.formKey}
        initialValues={{ ...pageState.formInitialValues }}
        render={(formRenderProps) => {
          return (
            <FormElement horizontal={false}>
              <FormRegion className="form-region-1">
                <div className="form-group form-group-1">
                  <TabStrip
                    selected={tabSelected}
                    onSelect={handleTabSelection}
                  >
                    <TabStripTab title={t("datasets.datasetview.info")}>
                      <div className="dataset-info">
                        <div className="k-form-field">
                          <label className="k-label">
                            {t("datasets.datasetview.consumption")}
                          </label>
                          <div className="dataset-grid">
                            <Grid
                              data={consumptionData}
                              scrollable="scrollable"
                              resizable={true} // Enable column resizing
                            >
                              <GridColumn
                                field="Dataset"
                                title={t("datasets.datasetview.dataset")}
                                width={150}
                              />
                              <GridColumn
                                field="RowsCount"
                                title={t("datasets.datasetview.rows")}
                                width={120}
                              />
                              <GridColumn
                                field="UsedSizeInMB"
                                title={t("datasets.datasetview.space")}
                                width={120}
                              />
                              <GridColumn
                                field="CleanedRowsCount"
                                title={t("datasets.datasetview.cleanedrows")}
                                width={150}
                              />
                              <GridColumn
                                field="RetentionPeriodInDays"
                                title={t("datasets.datasetview.retention")}
                                width={200}
                              />
                              <GridColumn
                                field="LastUpdatedOnUTC"
                                title={t("datasets.datasetview.lastupdate")}
                                width={150}
                              />
                            </Grid>
                          </div>
                        </div>
                        <Field
                          id={"Description"}
                          name={"Description"}
                          label={t("datasets.datasetview.description")}
                          component={FormTextArea}
                          style={{ height: 80 }}
                          disabled={true}
                        />
                        <Fragment>
                          <Field
                            id={"SourceType"}
                            name={"SourceType"}
                            label={t("datasets.datasetview.sourcetype")}
                            component={FormInput}
                            disabled={true}
                            maxLength={255}
                          />

                          <div className="k-form-field">
                            <label className="k-label">
                              {t("datasets.datasetview.datasetfields")}
                            </label>
                            <div className="dataset-grid">
                              <DatasetGrid
                                id="DatasetFields"
                                name="DatasetFields"
                                formValues={pageState.formValues}
                              />
                              {/* <Grid
                                data={updatedDatasetFields}
                                scrollable="scrollable"
                                resizable={true} // Enable column resizing
                                style={{ height: "300px" }}
                              >
                                {columns &&
                                  columns.map((col, idx) => (
                                    <GridColumn
                                      key={idx}
                                      field={col.field}
                                      title={
                                        col.field === "DataTypeId"
                                          ? "DataType"
                                          : col.title
                                      }
                                      width={col.width}
                                    />
                                  ))}
                              </Grid> */}
                            </div>
                          </div>
                        </Fragment>
                      </div>
                    </TabStripTab>
                    <TabStripTab
                      title={t("datasets.datasetview.configuration")}
                    >
                      <div
                        className="form-group form-group-1"
                        style={{ marginBottom: "50px" }}
                      >
                        <Field
                          id={"Title"}
                          name={"Title"}
                          label={t("datasets.datasetview.title")}
                          component={FormInput}
                          value={pageState.formValues.Title || ""}
                          type={"text"}
                          disabled={true}
                          onChange={(e) =>
                            handleOnChangeField("Title", e.value)
                          }
                        />
                        {pageState.formValues.SourceTypeId != 2 && (
                          <Fragment>
                            <Field
                              id={"DbConnection.DataBaseTypeId"}
                              name={"DbConnection.DataBaseTypeId"}
                              label={t("datasets.datasetview.datatype")}
                              component={FormDropDownListById}
                              data={databaseDDL}
                              dataItemKey="Id"
                              textField="Title"
                              value={
                                pageState.formValues.DbConnection
                                  ?.DataBaseTypeId
                              }
                              disabled={true}
                              onChange={(e) =>
                                handleOnChangeConnection(
                                  "DataBaseTypeId",
                                  e.value,
                                )
                              }
                            />
                            <Field
                              id={"DbConnection.Server"}
                              name={"DbConnection.Server"}
                              label={t("datasets.datasetview.server")}
                              component={FormInput}
                              value={
                                pageState.formValues.DbConnection?.Server || ""
                              }
                              type={"text"}
                              disabled={true}
                              onChange={(e) =>
                                handleOnChangeConnection("Server", e.value)
                              }
                            />
                            <Field
                              id={"DbConnection.DataBase"}
                              name={"DbConnection.DataBase"}
                              label={t("datasets.datasetview.database")}
                              value={
                                pageState.formValues.DbConnection?.DataBase ||
                                ""
                              }
                              component={FormInput}
                              type={"text"}
                              disabled={true}
                              onChange={(e) =>
                                handleOnChangeConnection("DataBase", e.value)
                              }
                            />
                            <Field
                              id={"DbConnection.Username"}
                              name={"DbConnection.Username"}
                              label={t("datasets.datasetview.username")}
                              value={
                                pageState.formValues.DbConnection?.Username ||
                                ""
                              }
                              component={FormInput}
                              type={"text"}
                              disabled={true}
                              onChange={(e) =>
                                handleOnChangeConnection("Username", e.value)
                              }
                            />
                            <Field
                              id={"DbConnection.Password"}
                              name={"DbConnection.Password"}
                              label={t("datasets.datasetview.password")}
                              component={FormInput}
                              type={"password"}
                              disabled={true}
                              onChange={(e) =>
                                handleOnChangeConnection("Password", e.value)
                              }
                            />

                            <Field
                              id="DatasetIsReccurent"
                              name="DatasetIsReccurent"
                              label={t("datasets.datasetview.reccurent")}
                              checked={
                                !!pageState.formValues.DatasetIsReccurent ||
                                pageState.formValues.RecurrsEvery > 0
                              }
                              component={FormCheckbox}
                              disabled={true}
                              onChange={(e) => {
                                console.log(e);
                                handleOnChangeField(
                                  "DatasetIsReccurent",
                                  e.target.value,
                                  null,
                                );
                              }}
                              className={"mb30"}
                            />
                            <Field
                              id={"RecurrsEvery"}
                              name={"RecurrsEvery"}
                              label={t("datasets.datasetview.recurs")}
                              component={FormDropDownListById}
                              data={timeIntervalsDDL}
                              dataItemKey="Id"
                              textField="Title"
                              value={pageState.formValues.RecurrsEvery || ""}
                              disabled={true}
                              onChange={(e) =>
                                handleOnChangeField("RecurrsEvery", e.value)
                              }
                            />
                          </Fragment>
                        )}
                      </div>
                    </TabStripTab>
                    <TabStripTab
                      title={t("datasets.datasetview.datacorrectionlogs")}
                    >
                      <div className="k-form-field">
                        {/* <label className="k-label">
                          Data Correction Summary
                        </label> */}
                        {updatedCorrectionColumns?.length == 0 && (
                          <div>{t("datasets.datasetview.nodata")}</div>
                        )}
                        {updatedCorrectionColumns?.length > 0 && (
                          <div className="dataset-grid">
                            <Grid
                              data={updatedCorrectionColumns}
                              scrollable="scrollable"
                              resizable={true} // Enable column resizing
                              rowRender={(row, rowProps) => {
                                // Add conditional styling
                                const isStatusOne =
                                  rowProps.dataItem.Status !== 1;
                                const customStyle = {
                                  backgroundColor: isStatusOne
                                    ? "rgba(255,0,0,0.4)"
                                    : undefined,
                                };

                                return cloneElement(
                                  row,
                                  {
                                    style: {
                                      ...row.props.style,
                                      ...customStyle,
                                    },
                                  },
                                  row.props.children,
                                );
                              }}
                            >
                              {correctionColumns &&
                                correctionColumns.map((col, idx) => (
                                  <GridColumn
                                    key={idx}
                                    field={col.field}
                                    title={col.field}
                                    width={col.width}
                                  />
                                ))}
                            </Grid>
                          </div>
                        )}
                      </div>
                    </TabStripTab>
                    <TabStripTab title={t("datasets.datasetview.job")}>
                      <div className="dataset-info">
                        <Fragment>
                          <div className="k-form-field">
                            <label className="k-label">
                              {t("datasets.datasetview.job")}
                            </label>
                            <div className="dataset-grid">
                              {pageState.formValues.JobCollection?.length >
                                0 && (
                                <Grid
                                  data={pageState.formValues.JobCollection}
                                  scrollable="scrollable"
                                  resizable={true}
                                  style={{ height: "300px" }}
                                >
                                  <GridColumn
                                    field="JobType"
                                    title={t("datasets.datasetview.jobtype")}
                                    cell={JobCollectionTypeCell}
                                  />
                                  <GridColumn
                                    field="TriggeredOn"
                                    title={t("datasets.datasetview.triggered")}
                                  />
                                  <GridColumn
                                    field="EndedOn"
                                    title={t("datasets.datasetview.endedon")}
                                  />
                                  <GridColumn
                                    field="ErrorCode"
                                    title={t("datasets.datasetview.errorcode")}
                                  />
                                  <GridColumn
                                    field="ErrorMessage"
                                    title={t("datasets.datasetview.errormsg")}
                                  />
                                  <GridColumn
                                    field="StackTrace"
                                    title={t("datasets.datasetview.stack")}
                                  />
                                  <GridColumn
                                    field="Status"
                                    title={t("datasets.datasetview.status")}
                                    cell={JobCollectionStatusCell}
                                  />
                                </Grid>
                              )}
                            </div>
                          </div>
                        </Fragment>
                      </div>
                    </TabStripTab>
                  </TabStrip>
                </div>
              </FormRegion>
            </FormElement>
          );
        }}
      />
      <style>
        {`        
                    .datasetview-page-form .k-form
                    {          
                        /*the kendo form which is child of my form.content*/     
                        width: 100%;
                        display: flex;
                        flex: 1;
                        justify-content: space-between;
                        padding: 0 24px 12px 24px;/*keep 12px in right and bottom so that when minimizing we keep a white region to the right and bottom; also keep 8px on the left*/
                    }

                    .datasetview-page-form .form-region-1
                    {
                        width: 100%;
                        max-width: 1000px;
                        margin-top: 20px !important;/*to override kendo first child of k-form having marginTop=0*/                     
                    }

                    .datasetview-page-form .form-region-1 .form-group-1
                    {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                    }
                   
                    .datasetview-page-form > .content
                    {
                        padding: 0px;
                        background-color: transparent;
                        align-items: flex-start;
                    }

                    .datasetview-page-form .form-region-root
                    {
                        background-color: transparent;
                    }

                    .datasetview-page-form input.k-input, .datasetview-page-form textarea.k-textarea, 
                    .datasetview-page-form .k-dropdownlist .k-input-inner
                    {
                        /*make input controls have a bit more height*/
                        padding: 6px 8px;
                    }

                    .datasetview-page-form .form-region-root .list-container.groups
                    {
                        border: 1px solid ${currentTheme.componentBorderColor};
                        border-radius: 4px;
                        margin-top: 2px;
                        flex: 1;
                        max-height: 180px;
                    }

                    .datasetview-page-form .form-region-root .list-container.groups .list-root
                    {
                        display: flex !important;
                        flex-wrap: wrap;   
                    }

                    .datasetview-page-form .form-region-root .list-container.groups .list-item
                    {
                        display: flex !important;
                        width: 50%;
                        overflow-x: hidden;
                    }

                   .datasetview-page-form .k-animation-container.k-animation-container-relative{
                    width:100%;
                   }

                   .datasetview-page-form .toolbar .k-button{
                   border:none;
                   }
                `}
      </style>
    </Fragment>
  );
};
